export const SHORTLISTING_SECTION_TITLE = 'AI Shortlist';

export const SHORTLISTING_ENABLED_LABEL = 'AI Shortlist';

export const NATIONALITY_SCRUTINY_ENABLED_LABEL = 'Nationality scrutiny';

export const APPLICATION_ANSWER_EVIDENCE_ENABLED_LABEL =
  'Application answers as criteria evidence';

export const SHORTLISTING_DATA_TEST_ID = 'shortlisting-form';
